export const getSelectionRange = () => {
    const selection = window.getSelection();
    if (selection.rangeCount === 0) return null;
    return selection.getRangeAt(0);
};



// WEBPACK FOOTER //
// ./src/components/controls/RichEditor/utils/getSelectionRange.js